// src/auth/pages/ResetPasswordPage.jsx
import React from "react";
// ✅ Fixed path based on your routes config
import ForgotPasswordController from "../pre/SEC_02_03_ForgotPasswordController";

/**
 * ResetPasswordPage
 * Provides the consistent layout container (520px max-width)
 * for the password reset initiation and completion flows.
 */
export default class ResetPasswordPage extends React.Component {
  render() {
    return (
      <div style={{ maxWidth: 520, margin: "0 auto" }}>
        {/* ✅ renamed to ForgotPasswordController for PascalCase compliance */}
        <ForgotPasswordController />
      </div>
    );
  }
}